import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTranslate, useDataProvider, Title, usePermissions, Loading } from 'react-admin';
import { useAuthProvider } from 'ra-core';
import PageListLabel from '../page-list-label';
import MovieTable from './ListContentMovie';
import Snackbar from '../common/snackbar';
import FakeData from './fakedata.json';
import { useLocation } from 'react-router';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
export const ListMovie = ({ }) => {
    const authProvider = useAuthProvider();
    const { permissions, loaded } = usePermissions();
    const [isPermission, setIsPermission] = useState(true);
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [search, setSearchText] = useState('');
    const [showSnackbarDelete, setShowSnackbarDelete] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false)
    const [sort, setSort] = useState({
        field: 'name',
        order: 'ASC'
    })
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10
    })

    const getList = () => {

        let filter = { text: search.trim() };

        dataProvider('GET_LIST', "medias", {
            filter,
            pagination,
            sort,
        }).then(response => {
            if (response.success) {
                setData(response.data);
                setTotalCount(response.total);
            }
        }).catch(error => {
            // if (error.message === 'permissionIncorect') {
            //     setIsPermission(false)
            //     authProvider.resetFunctionAction()
            // }
        });
    }

    const handleDelete = () => {
        var requests = []
        data.forEach(element => {
            element.checked && requests.push(
                dataProvider('DELETE', "medias", {
                    id: element.id
                })
            )
        })
        if (requests.length > 0) {
            Promise.all(requests).then(() => {
                getList()
                setOpenConfirmDialog(false)
            }).catch(error => {
                setOpenConfirmDialog(false)
            });
        }
        else
            setOpenConfirmDialog(false)

    }



    // const onGetListUser = (sortObj, paginationObj) => {

    //     pagination = paginationObj;
    //     sort = sortObj;
    //     getListUser();
    // }

    const handleCheckMark = (event, index, checkAll) => {
        let temps = data.slice()
        if (!checkAll)
            temps[index].checked = event.target.checked
        else
            temps.map(item => {
                item.checked = event.target.checked
                return item
            })
        setData(temps)
    }

    const onClear = () => {
        let temps = data.slice()
        temps.map(item => {
            delete item.checked
            return item
        })
        setData(temps)
    }

    const onGetList = (sortObj, paginationObj) => {
        setSort(sortObj)
        setPagination(paginationObj)
    }

    useEffect(() => {
        getList();
    }, [sort, pagination])

    useEffect(() => {
        if (location.state && location.state.open) {
            setShowSnackbar(true);
            setTimeout(() => {
                setShowSnackbar(false);
            }, 6000);
        }
    }, [])

    if (!loaded) return null

    return (
        <Box mt={5} py={2} width={!isDesktop ? '95%' : '80%'} m='auto'>
            <Box width='100%' display='flex' justifyContent='flex-end'>
                <Snackbar
                    show={showSnackbar}
                    boldText={location.state && location.state.name}
                    message={location.state && location.state.message}
                    onClose={() => setShowSnackbar(false)}
                />

            </Box>
            <PageListLabel
                label={translate(`pos.media.movie`)}
                buttonHidden={
                    !permissions.functionAction.find(value => value.function === 'Media' && value.isUpdate)
                }
                searchPlaceholder={translate(`pos.media.searchMovie`)}
                btnText={translate(`pos.media.addMovie`)}
                onChangeText={setSearchText}
                pathname='/Media/create'
                getList={getList}
                total={totalCount}
            />
            <MovieTable
                // handleDelete={handleDelete}
                buttonHidden={
                    !permissions.functionAction.find(value => value.function === 'Media' && value.isUpdate)
                }
                data={data}
                checked={data.length > 0 && data.filter(item => item.checked)}
                handleCheckMark={handleCheckMark}
                onDelete={() => {
                    setOpenConfirmDialog(true)
                }}
                onClear={onClear}
                // setData={setUser}
                total={totalCount}
                getList={onGetList}
                setSort={setSort}
                sort={sort}
            // error={user.length}
            />
            <ConfirmDialog
                open={openConfirmDialog}
                handleClose={() => { setOpenConfirmDialog(false) }}
                handleConfirm={handleDelete}
                ContentText={translate(`pos.movie.confirmDelete`)}
                Tittle={translate(`pos.movie.delete`)} />
        </Box>
    );
}

export default ListMovie;